<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import {ref} from "vue";
import type {AddressFilter} from "@/types/Wiser/address.ts";
import AddressFilterForm from "@/views/Wiser/AddressFilterForm.vue";
const modelFilter = ref<AddressFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <AddressFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-address" model="Address" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
